import { useMediaQuery } from '../../useMediaQuery';
import { OVERLAY_QUERY, derivePanelTogglesHost, type PanelTogglesHost } from './flow-panels-layout';
import { useFlowPanelsStore } from './flow-panels-store';

/**
 * The ONE place `derivePanelTogglesHost` (`flow-panels-layout.ts`) is read
 * outside the layout math — replaces round 2's `useFlowPanelsCollapsed.ts`
 * (Spencer QA round 3: the toggles pin to the whole shell's top-right corner,
 * so the Actions strip hosts them whenever Actions is open in push mode, not
 * only while Flow is collapsed). Composes the one store flag the formula
 * needs plus the same `OVERLAY_QUERY` media query `FlowPanels` uses to pick
 * a mode, so the two hosts — `shell-next/Header.tsx` and `rail/RailDock.tsx`
 * — never reimplement the mode derivation or disagree with each other. One
 * selector subscription: a drag-share write must not re-render either host.
 */
export function usePanelTogglesHost(): PanelTogglesHost {
  const actionsOpen = useFlowPanelsStore((s) => s.actionsOpen);
  const overlay = useMediaQuery(OVERLAY_QUERY);
  return derivePanelTogglesHost({ actionsOpen, mode: overlay ? 'overlay' : 'push' });
}
